module.exports = __webpack_public_path__ + "img/NISSAN-Leaf-2.eeec62e0.jpeg";